import React from "react";

const PerformanceIndicatorBar = ({
  title,
  badgeText,
  badgeBg = "#e0f2fe",
  badgeColor = "#0369a1",
  percent,
  labels = [],
}) => {
  return (
    <div className="mb-4">
      <div className="d-flex align-items-center justify-content-between mb-2">
        <span className="text-muted" style={{ fontSize: "14px" }}>
          {title}
        </span>
        <span
          className="badge px-3 py-1 rounded-pill"
          style={{
            backgroundColor: badgeBg,
            color: badgeColor,
            fontSize: "13px",
            fontWeight: "600",
          }}
        >
          {badgeText}
        </span>
      </div>
      <div
        className="progress"
        style={{
          height: "8px",
          backgroundColor: "#f1f5f9",
          borderRadius: "4px",
        }}
      >
        <div
          className="progress-bar"
          role="progressbar"
          style={{
            width: `${percent}%`,
            backgroundColor: "#0284c7",
            borderRadius: "4px",
            transition: "width 0.4s ease",
          }}
          aria-valuenow={percent}
          aria-valuemin="0"
          aria-valuemax="100"
        />
      </div>
      <div
        className="d-flex justify-content-between text-muted mt-1"
        style={{ fontSize: "11px" }}
      >
        {labels.map((lbl, idx) => (
          <span key={idx}>{lbl}</span>
        ))}
      </div>
    </div>
  );
};

export default PerformanceIndicatorBar;
